/**
 * Progressive-enhancement accordion for the 3 footer link groups (Objevte /
 * Ostrov / Praktické). The "brand" column (logo + tagline) is left alone.
 * CSS in brand-tokens.css only visually collapses/expands at mobile widths
 * (max-width:749px); this script runs unconditionally and is inert on
 * desktop since the collapsed state never applies there.
 *
 * Wraps each group's non-heading children in a single panel element so the
 * 0fr/1fr grid-rows collapse technique in CSS has exactly one sized target,
 * rather than trying to independently collapse every link.
 */
(function () {
  var groups = document.querySelectorAll(
    '#shopify-section-footer_main .footer-content > .group-block:not(:first-child)'
  );
  if (!groups.length) return;

  groups.forEach(function (group) {
    var content = group.querySelector(':scope > .group-block-content');
    if (!content || content.children.length < 2) return;

    var heading = content.children[0];

    var inner = document.createElement('div');
    inner.className = 'footer-accordion__panel-inner';
    while (content.children.length > 1) {
      inner.appendChild(content.children[1]);
    }

    var panel = document.createElement('div');
    panel.className = 'footer-accordion__panel';
    panel.appendChild(inner);
    content.appendChild(panel);

    heading.classList.add('footer-accordion__trigger');
    heading.setAttribute('role', 'button');
    heading.setAttribute('tabindex', '0');
    heading.setAttribute('aria-expanded', 'false');

    var toggle = function () {
      var isOpen = group.classList.toggle('is-open');
      heading.setAttribute('aria-expanded', String(isOpen));
    };

    heading.addEventListener('click', toggle);
    heading.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggle();
      }
    });
  });
})();
